import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <div className="header-content">
        {/* <div className="header-left">
          <h1 className="page-title">Influencer Panel</h1>
        </div> */}
        <div className="header-right">
          <div className="user-info">
            <span className="user-name">Hi,</span>
            <div className="user-avatar">
              <img src="/api/placeholder/40/40" alt="User" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;